import { render } from "./ConvertorForm.vue?vue&type=template&id=08233672&scoped=true"
import script from "./ConvertorForm.vue?vue&type=script&lang=js"
export * from "./ConvertorForm.vue?vue&type=script&lang=js"

import "./ConvertorForm.vue?vue&type=style&index=0&id=08233672&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08233672"

export default script